import { render, staticRenderFns } from "./rightForm.vue?vue&type=template&id=4535261f&scoped=true&"
import script from "./rightForm.vue?vue&type=script&lang=js&"
export * from "./rightForm.vue?vue&type=script&lang=js&"
import style0 from "./rightForm.vue?vue&type=style&index=0&id=4535261f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535261f",
  null
  
)

export default component.exports